"use client";

import { ChatBody } from "./ChatBody";
import type { Faq } from "./ChatProvider";
import styles from "./FaqChat.module.css";

/**
 * The FAQ section as a chat. Typed questions are answered by /api/chat from
 * the site's own content; suggested questions answer at once from the written
 * FAQ. The floating chat hides while this is on screen (data-faq-chat). The
 * full list stays below, open to search engines and screen readers.
 */
export function FaqChat({ faqs, name = "ION" }: { faqs: Faq[]; name?: string }) {
  return (
    <div className={styles.wrap} data-faq-chat>
      <div className={styles.panel}>
        <ChatBody faqs={faqs} name={name} />
      </div>

      {/* Every answer in plain text, for search engines, screen readers and
          anyone who would rather read than ask. */}
      <details className={styles.all}>
        <summary>Browse all questions</summary>
        <dl>
          {faqs.map((f) => (
            <div key={f.q}>
              <dt>{f.q}</dt>
              <dd>{f.a}</dd>
            </div>
          ))}
        </dl>
      </details>
    </div>
  );
}
